import React, { ComponentPropsWithoutRef, FC } from 'react';
import cx from 'classnames';

import { Override } from 'types/common';

import styles from './styles.module.css';

type ContainerProps = Override<ComponentPropsWithoutRef<'div'>, {
  fluid?: boolean;
}>;

const Container: FC<ContainerProps> = ({ className, fluid, ...props }) => (
  <div
    className={cx(
      styles.root,
      fluid && styles.root_fluid,
      className,
    )}
    {...props}
  />
);

export default Container;
